require('./manageEmailNotification.i18n.json');
require('./manageEmailNotification.tpl.html');
require('./notificationEmailTemplateModel.js');
require('./header/manageEmailNotificationHeaderComponent.js');

/*@ngInject*/
const ManageEmailNotificationController = function ($scope, $rootScope, $stateParams, localization, configurationConstant, notificationPreferencesAction, notificationEmailTemplateRepository, notificationEmailTemplateModel, emailEditorConstant, configurationMediator, currentUserModel, authorizationConstants) {

    localization.getTranslations('manageEmailNotification').then(function (translations) {
        $scope.viewModel = {
            backButtonLabel: _.get(translations, 'backButtonLabel'),
            notificationPreferencesAction: notificationPreferencesAction,
            templateId: $stateParams.templateId,
            notificationEmailTemplate: {
                enabled: true,
                defaultSelectedOption: 'STANDARD',
                deletable: true
            },
            namePrompt: translations.manageEmailNotification.namePrompt,
            recipientList: [],
            isReadOnly : !currentUserModel.hasAuthorization(authorizationConstants.MODIFY_CONFIG_EMAIL),
            emailOptions: {
                email: {}
            }
        };

        if ($stateParams.templateId) {
            notificationEmailTemplateRepository.getNotificationEmailTemplate($stateParams.templateId).then(function (notificationEmailTemplate) {
                $scope.viewModel.notificationEmailTemplate = _.cloneDeep(notificationEmailTemplate);
                notificationEmailTemplateModel.reset();
                notificationEmailTemplateModel.notificationEmailTemplate = $scope.viewModel.notificationEmailTemplate;
                $scope.viewModel.emailOptions.email = $scope.viewModel.notificationEmailTemplate;
                if (!_.isNil($scope.viewModel.emailOptions.email.body)) {
                    $scope.viewModel.emailOptions.email.body = $scope.viewModel.emailOptions.email.body.replace(/&lt;/g, '<').replace(/&gt;/g, '>').replace(/&amp;nbsp;/g, ' ');
                }
                _.each($scope.viewModel.emailOptions.email.to, function (item) {
                    return item.valid = true;
                });
                _.each($scope.viewModel.emailOptions.email.cc, function (item) {
                    return item.valid = true;
                });
                _.each($scope.viewModel.emailOptions.email.bcc, function (item) {
                    return item.valid = true;
                });

                $rootScope.$broadcast(configurationConstant.event.EMAIL_TEMPLATE_UPDATED);
            });
        }

        configurationMediator.loadRecipients().then(function (recipients) {
            _.each(recipients['Submission Roles'], function (recipient) {
                recipient.grouping = 'Submission Roles';
                recipient.group = 'Submission Roles';
            });
            _.each(recipients['Carrier Users'], function (carrierRecipient) {
                carrierRecipient.grouping = 'Carrier Users';
                carrierRecipient.group = 'Carrier Users';
                carrierRecipient.name = carrierRecipient.firstName + ' ' + carrierRecipient.lastName;
            });
            const recipientList = recipients['Carrier Users'].concat(recipients['Submission Roles']);
            $rootScope.$broadcast(emailEditorConstant.event.PEOPLE_LIST_LOADED, recipientList);
        });

        notificationEmailTemplateModel.notificationEmailTemplate = $scope.viewModel.notificationEmailTemplate;


    });

    $scope.handleChange = function () {
        notificationEmailTemplateModel.hasUnsavedChanges = true;
        notificationEmailTemplateModel.isValid = isValid();
        $rootScope.$broadcast(configurationConstant.event.EMAIL_TEMPLATE_UPDATED);
    };

    function isValid() {
        const hasName = !_.isEmpty(notificationEmailTemplateModel.notificationEmailTemplate.name),
            hasStatus = notificationEmailTemplateModel.notificationEmailTemplate.enabled !== null,
            hasDefaultSelected = !_.isEmpty(notificationEmailTemplateModel.notificationEmailTemplate.defaultSelectedOption);

        let result = false; // we need to always return something if the method is intended to return something

        if (hasName && hasStatus && hasDefaultSelected) {
            result = true;
        }
        return result;
    }

    function getRecipient(recipients) {
        const recipientList = [];
        _.each(recipients, function (emailRecipient) {
            let recipient = {};
            if (!_.isNil(emailRecipient.emailAddress)) {
                if (emailRecipient.emailAddress.indexOf('@') > 0) {
                    recipient.email = emailRecipient.emailAddress;
                } else {
                    recipient.email = emailRecipient.emailAddress;
                    recipient.role = emailRecipient.emailAddress;
                }
            } else {
                if (!_.isNil(emailRecipient.description)) {
                    recipient.email = emailRecipient.description;
                    recipient.role = emailRecipient.description;
                } else {
                    recipient.email = emailRecipient.name;
                }

            }
            recipientList.push(recipient);
        });
        return recipientList;
    }

    $scope.$on(emailEditorConstant.event.EMAIL_UPDATE_COMPLETE, function (event, email, isEmailBodyChange) {

        if (!isEmailBodyChange
            || isEmailBodyChange && notificationEmailTemplateModel.notificationEmailTemplate.body !== email.body) {
            notificationEmailTemplateModel.hasUnsavedChanges = true;
            notificationEmailTemplateModel.isValid = isValid();
            $rootScope.$broadcast(configurationConstant.event.EMAIL_TEMPLATE_UPDATED);
        }

        notificationEmailTemplateModel.notificationEmailTemplate.to = getRecipient(email.to);
        notificationEmailTemplateModel.notificationEmailTemplate.bcc = getRecipient(email.bcc);
        notificationEmailTemplateModel.notificationEmailTemplate.cc = getRecipient(email.cc);
        notificationEmailTemplateModel.notificationEmailTemplate.subject = !_.isNil(email.subject) ? email.subject : '';
        notificationEmailTemplateModel.notificationEmailTemplate.body = !_.isNil(email.body) ? email.body : '';
        notificationEmailTemplateModel.notificationEmailTemplate.type = !_.isNil(email.type) ? email.type : '';

    });
};

angular.module('ums.configuration')
    .controller('manageEmailNotificationController', ManageEmailNotificationController);
